import React from "react";
import PropTypes from "prop-types";
import arrowIcon from "../../assets/images/link_arrow_big_icon.svg";
import defaultAvatar from "../../assets/images/User.png";
import { Link } from "react-router-dom";

const WidgetsCard = ({
  title,
  count,
  percentage,
  percentageText,
  trend = "increase",
  link,
  className = "",
  avatars = [],
}) => {
  const isActive = className.includes("gradiant_bg");
  const BASE_URL = process.env.REACT_APP_IMAGE_BASE_URL || "";

  return (
    <div className={`widgets_card ${className}`}>
      <div className="d-flex justify-content-between align-items-start h-100">

        {/* LEFT CONTENT */}
        <div>
          <h5 className={`mb-0 ${isActive ? "text-white" : ""}`}>
            {title}
          </h5>

          <h2 className={`count mt_22 mb_15 ${isActive ? "text-white" : ""}`}>
            {count}
          </h2>

          <div className="d-flex align-items-center gap-2">
            {/* AVATAR STACK */}
            {avatars.length > 0 && (
              <div className="avatar_stack">
                {avatars.map((img, i) => (
                  <img key={i} src={img ? BASE_URL + img : defaultAvatar} alt="avatar" />
                ))}
              </div>
            )}

            {title !== "Pending Payments" ? (
              <p
                className={`mb-0 ${isActive
                  ? "text-white"
                  : trend === "increase"
                    ? "text-primary"
                    : "text-danger"
                  }`}
              >
                <span
                  style={{
                    border: `1px solid ${trend === "increase" ? "#0d6efd" : "#dc3545"}`
                  }}
                >
                  {percentage}%
                </span>{" "}
                {percentageText}
              </p>
            ) : (
              <p>
                <Link
                  to={link}
                  className="mb-0 text-primary"
                >
                  View All
                </Link></p>
            )}
          </div>
        </div>

        {/* RIGHT ICON */}
        {link && (
          <a href={link} className="icon_circle">
            <img src={arrowIcon} alt="arrow" />
          </a>
        )}
      </div>
    </div>
  );
};

WidgetsCard.propTypes = {
  title: PropTypes.string.isRequired,
  count: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  percentage: PropTypes.number,
  percentageText: PropTypes.string,
  trend: PropTypes.oneOf(["increase", "decrease"]),
  link: PropTypes.string,
  className: PropTypes.string,
  avatars: PropTypes.arrayOf(PropTypes.string),
};

export default WidgetsCard;
